
import axios from "axios";
import React, { Component}  from 'react';
import styled from 'styled-components';
import { TariffPointServicesForm } from './FormPointServices'
import FormControl from '@material-ui/core/FormControl';
import ClearIcon from '@material-ui/icons/Clear';
import _ from 'lodash';
import IconButton from '@material-ui/core/IconButton';
import { AsyncAutocompleteWidget2 } from 'form/AutocompleteWidget2';


const Index = styled.div`
  border: 1px solid #333333;
  border-radius: 2px;
  font-weight: bold;
  text-align: center;
  line-height: 24px;
`;

const StyledTariffPointForm = styled.div`
  display: grid;
  grid-template-columns: 34px 1fr 110px 48px;
  grid-gap: 10px;
  margin-bottom: 20px;
  align-items: center;

  .address {
    color: #828282;
  }
`;

const StyledTariffPointForm2 = styled.div`
  display: grid;
  grid-template-columns: 34px 1fr;
  grid-gap: 10px;
  margin-bottom: 20px;
  font-weight: 500;
  font-size: 12px;
  align-items: center;
`;


function BaseTariffCost({pointId, serviceId, baseTariffCost}) {
  const index = baseTariffCost.findIndex((obj) => obj.point === pointId && obj.service.id === serviceId);
  if (index !== -1) {
    return baseTariffCost[index].cost;
  }
  return '-';
}



export class TariffPointIndividualForm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      baseTariffCost: []
    }
  }

  componentDidMount() {
    const { point, context } = this.props;
    this.loadBaseTariffCost(context.item.base_tariff, point.id);
  }

  getTariffPoints = (pointId) => {
    const { context } = this.props;
    return _.filter(context.item.tariff_points, function(o) {
      return o.point === pointId && !o.is_delete;
    });
  };

  findPointServiceIndex = (serviceId, pointId) => {
    const { context } = this.props;
    return context.item.tariff_points.findIndex(
      o => o.service.id === serviceId && o.point === pointId
    );
  };

  removePointService = (serviceId, pointId) => {
    const { context } = this.props;
    const index = this.findPointServiceIndex(serviceId, pointId);
    if (index !== -1) {
      let point_service = context.item.tariff_points[index];
      if (point_service.id) {
        context.setValue(`tariff_points.${index}.cost`, 0);
        context.setValue(`tariff_points.${index}.is_delete`, true);
      }
      else {
        context.removeArrayValue(`tariff_points`, index);
      }
    }
  };

  findBaseTariffCost = (point, service) => {
    const { baseTariffCost } = this.state;
    const index = baseTariffCost.findIndex((obj) => obj.point === point && obj.service.id === service);
    if (index !== -1) {
      return baseTariffCost[index].cost;
    }
    return '-';
  };

  removePoint = (pointId) => {
    const { context } = this.props;
    const point_services = _.filter(context.item.tariff_points, (obj) => obj.point === pointId);
    _.forEach(point_services, (point_service) => {
      const index = this.findPointServiceIndex(point_service.service.id, pointId);
      if (point_service.id) {
        context.setValue(`tariff_points.${index}.cost`, 0);
        context.setValue(`tariff_points.${index}.is_delete`, true);
      }
      else {
        context.removeArrayValue(`tariff_points`, index);
      }
    });
  };

  loadBaseTariffCost = (baseTariffId, pointId) => {
    axios.get(
      'tariff/point_service', {params: {tariff: baseTariffId, point: pointId}}
    ).then(res => {
      this.setState({
        baseTariffCost: res.data.results
      })
    })
  }

  handlePointChange = (option, index) => {
    const { context, onPointChange } = this.props;
    const tariff = context.item;
    onPointChange(option, index);
    if (option) {
      this.loadBaseTariffCost(tariff.base_tariff, option.id);
    }
    else {
      this.setState({
        baseTariffCost: []
      })
    }
  }

  render() {
    const { context, point, onPointDelete, index } = this.props;
    const { baseTariffCost } = this.state;
    const tariffPoints = this.getTariffPoints(point ? point.id : null);

    return (
      <React.Fragment>
        <StyledTariffPointForm>
          <div>
            <Index>{index + 1}</Index>
          </div>
          <div>
            <FormControl fullWidth={true} required={true} variant="outlined" className={'mb-0'}>
              <AsyncAutocompleteWidget2
                value={point}
                url={'catalog/point'}
                autocompleteProps={{
                  disableClearable: true
                }}
                onChange={(optionId, option) => this.handlePointChange(option, index)}
              />
            </FormControl>
          </div>
          <div>
            {point.id && (
              <TariffPointServicesForm
                context={context}
                point={point}
              />
            )}
          </div>
          <div>
            <IconButton
              tabIndex={'-1'}
              onClick={() => onPointDelete(context, point.id)}
            >
              <ClearIcon />
            </IconButton>
          </div>
        </StyledTariffPointForm>
        {tariffPoints.length > 0 && (
        <StyledTariffPointForm2>
          <div />
          <div>
            {tariffPoints.map((tariffPoint, tariffPointIndex) =>
              <div className={'mb-5'} key={tariffPointIndex}>
                <span className={'mr-5'}>{tariffPointIndex + 1}.</span>
                <span className={'mr-5'}>{tariffPoint.service.label},</span>
                <span className={'mr-5'}>было <BaseTariffCost pointId={point.id} serviceId={tariffPoint.service.id} baseTariffCost={baseTariffCost} />,</span>
                <span className={'mr-5'}>стало {tariffPoint.cost} ₽</span>

                <IconButton tabIndex={'-1'} size={'small'} onClick={() => this.removePointService(tariffPoint.service.id, tariffPoint.point)}>
                  <ClearIcon />
                </IconButton>
              </div>
            )}
          </div>
        </StyledTariffPointForm2>
        )}
      </React.Fragment>
    )
  }
}
